import { useCallback, useEffect, useState } from 'react';
import { useAppState } from './app-state';
import { useCollapseExpand } from './collapse-expand';
import { useBehaviour } from './editor-settings';
import { useServices } from './services-registry';
import { ViewMode } from '../types/host-sdk';

export const useVisibilityHandler = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { hostSdk } = useServices();
  const { collapse } = useCollapseExpand();
  const {
    appState: { hasMessages, isVisible },
    updateAppState,
  } = useAppState();
  const { getShouldShowOnPage } = useShouldShowOnPage();

  const visibilityHandler = useCallback(async () => {
    const isShouldShowOnPage = await getShouldShowOnPage();
    const changeRequired = isShouldShowOnPage !== isVisible;

    if (changeRequired || !isLoaded) {
      setIsLoaded(true);
      if (isShouldShowOnPage) {
        collapse();
        updateAppState({ isVisible: true });
      } else {
        collapse();
        updateAppState({ isVisible: false });
        void hostSdk.resizeTo(0, 0);
      }
    }
  }, [hostSdk.getCurrentPageId, isVisible, collapse, hasMessages, isLoaded]);

  useEffect(() => {
    return hostSdk.subscribeToPageNavigation(visibilityHandler);
  }, [hostSdk.getCurrentPageId, isVisible, collapse, hasMessages]);

  useEffect(() => {
    void visibilityHandler();
  }, [hasMessages]);
};

export const useShouldShowOnPage = () => {
  const { hostSdk } = useServices();
  const { pagesWithChat } = useBehaviour();
  const {
    appState: { hasMessages },
  } = useAppState();

  const getShouldShowOnPage = useCallback(async () => {
    const currentPageId = await hostSdk.getCurrentPageId();
    return (
      hostSdk.getViewMode() === ViewMode.Standalone ||
      pagesWithChat.includes(currentPageId) ||
      pagesWithChat.includes('*') ||
      hasMessages
    );
  }, [hostSdk, pagesWithChat, hasMessages]);

  return { getShouldShowOnPage };
};
